module.exports = __webpack_public_path__ + "img/clubicon-cards.33bd3905.png";